<template>
  <div>
    <omk-button
      v-show="whitelabel.omDesign"
      @click="accessButtonClicked"
      :button-type="'filled-button'"
      :button-size="this.isMobile ? 'small' : 'medium'"
      class="omk-button"
    >
      {{ buttonText }}
    </omk-button>
    <a
      v-show="!whitelabel.omDesign"
      @click="accessButtonClicked"
      class="access-btn"
    >
      <v-btn rounded elevation="0" outlined>
        <span>{{ buttonText }}</span>
      </v-btn>
    </a>
  </div>
</template>

<script>
export default {
  name: "AccessButton",
  components: {},
  data() {
    return {};
  },
  props: {
    buttonText: {
      required: true,
      default: "",
      type: String,
    },
  },
  methods: {
    accessButtonClicked() {
      this.$emit("accessButtonClicked");
    },
  },
  computed: {
    isMobile() {
      return this.$isMobileDevice();
    },
  },
};
</script>

<style scoped lang="scss">
.access-btn {
  button {
    background-color: white;
    border-color: #ccc;
  }
}
.omk-button {
  margin-left: 11px;
}
</style>
